import React from "react";
import { Disclosure } from "@headlessui/react";
import classNames from "classnames";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

interface CollapsibleProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  headerRight?: React.ReactNode;
  className?: string;
  buttonClassName?: string;
  contentClassName?: string;
}

const Collapsible: React.FC<CollapsibleProps> = ({
  title,
  children,
  defaultOpen = false,
  headerRight,
  className = "",
  buttonClassName = "",
  contentClassName = "",
}) => {
  return (
    <Disclosure as="div" className={className} defaultOpen={defaultOpen}>
      {({ open }) => (
        <>
          <Disclosure.Button
            className={classNames(
              "flex w-full justify-between items-center text-left",
              buttonClassName
            )}
          >
            <div className="flex-1">{title}</div>
            {headerRight && <div className="mr-2">{headerRight}</div>}
            <div className="flex-shrink-0 transition-transform duration-300">
              {open ? <FiChevronUp /> : <FiChevronDown />}
            </div>
          </Disclosure.Button>

          <Disclosure.Panel className={contentClassName}>
            {children}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default Collapsible;
